let getApi = () => import('@/services/Api');

const state = {
	rows: [],
	rowsCount: 0,
	requestParams: {},
	requestFinalParams: {},
	filterPredicts: [],
	isParanoid: false,
	filter: false,
	fileDialog: false,
	tableUpdater: 0,
	assetSearchInputValue: null,
	assetSearchInputCheck: false,
};

const getters = {

	getAssetSearchInputValue: (state) => state.assetSearchInputValue,
	getAssetSearchInputCheck: (state) => state.assetSearchInputCheck,
	getIsParanoid: (state) => state.isParanoid,
	getTableRows: state => state.rows,// state => JSON.parse(JSON.stringify(state.rows)),
	getTableRowsCount: state => state.rowsCount || 0,
	getTableRequestParams: state => state.requestParams,
	getTableFinalParams: state => state.requestFinalParams,
	getTableFilterPredicts: (state, getters, rootState, rootGetters) => {
		const item = state.filterPredicts.find(one => one.table === rootGetters.getCurrentTableName && one.route === rootGetters.getRouteName);
		return (item) ? item.arr : null;
	},
	getFilter: state => state.filter,
	getFileDialog: state => state.fileDialog,
	getFilterFields: (state, getters) => {
		//уберем ограничения диалогового окна
		let headers = JSON.parse(JSON.stringify(getters.getCurrentTableHeader));
		const filter = getters.getTableFilterPredicts;
		let conditions = [
			{value: 'eq', text: '='},
			{value: 'like', text: 'like'},
			{value: 'gt', text: '>'},
			{value: 'lt', text: '<'},
		]
		if(headers && headers.length > 0) {
			for (let i = 0; i < headers.length; i++) {
				headers[i].showFrm = null;
				headers[i].required = false;
				headers[i].oper = conditions[0];
				if(['TEXT', 'ML'].includes(headers[i].type)) {
					headers[i].type = 'STRING';
				}
				const predict = (filter) ? filter.find(one => one.value === headers[i].init) : null
				if(predict) {
					headers[i].oper = conditions.find(c => c.text === predict.operator)
				}
			}
		}
		return headers
	},
	getTableUpdater: (state) => state.tableUpdater
}

const actions = {
	storeIsParanoid({commit}, payload) {
		commit('setIsParanoid', payload.paranoid)
	},
	storeAssetSearchInputValue({commit}, payload) {
		commit('setAssetSearchInputValue', payload.val)
	},
	storeAssetSearchInputCheck({commit}, payload) {
		commit('setAssetSearchInputCheck', payload.val)
	},
	storeFilter({commit, getters}, payload) {
		if(payload.filter === true) {
			let initItem = {}
			let fields = getters.getCurrentTableHeader;
			let filtered = getters.getTableFilterPredicts;
			fields.forEach(function (field) {
				const predict = (filtered) ? filtered.find(one => one.value === field.init) || {} : {}
				if(!initItem[field.value]) {
					initItem[field.value] = predict.text;
					if(field.type === 'REF') {
						initItem[field.value] = {table: field.table, id: predict.text};
					}
					if(field.type === 'ML') {
						initItem[field.value] = predict.text;
					}
				}
			});
			commit('setMutated', initItem);
		}
		commit('setFilter', payload.filter)
	},
	storeTableRequestParams({commit}, payload) {
		commit('setTableRequestParams', payload)
	},
	storeTableFinalParams({commit}, payload) {
		commit('setTableFinalParams', payload)
	},
	storeTableFilterPredicts({commit, rootGetters}, payload) {
		commit('setTableFilterPredicts', {
			table: rootGetters.getCurrentTableName,
			arr: payload.val,
			route: rootGetters.getRouteName
		});
	},
	async storeTableRows({commit, getters, rootGetters, dispatch}, payload = {}) {
		let {progress = true} = payload;
		//по умолчанию сервис просмотра содуржимого
		let url = `/view/${rootGetters.getCurrentTableName}`;
		let params = {paranoid: getters.getIsParanoid, lang: rootGetters.getChosenLang};
		//данные по пагинации vutify
		const tableViewParams = getters.getTableRequestParams
		params.sort = tableViewParams.pagination || [];
		//если используется фильтр на таблице
		params.where = [...tableViewParams.predicts || [], ...getters.getTableFilterPredicts || []];
		//дист нужно добавить во все запросы
		let {id: userDistributionPointId = 0} = rootGetters.getDistributionPoint || {};
		const {id: distributionPoint = userDistributionPointId} = rootGetters.getAppDistributionPoint || {};
		params.where.push({value: 'distributionPointId', text: distributionPoint});
		//если в пути есть ограничения на данные,
		const routerParams = rootGetters.getRouteParams;
		if(routerParams) {
			let needExtParams = true;
			const {chart, filter, value} = routerParams;
			const assetGroupOperators = {equipment: '<', ppe: '>'};
			const assetGroup = (routerParams.query || {}).assetGroup;
			if(rootGetters.getCurrentTableName === 'Asset' && assetGroupOperators[assetGroup]) {
				params.where.push({value: 'identNumber', text: '500000', operator: assetGroupOperators[assetGroup]});
			}
			if(rootGetters.getRouteName === 'TableWithCondition') {
				params.where.push({value: filter, text: value});
			} else if(rootGetters.getRouteName === 'ShowLogs') {
				params.where.push({value: 'entetyObjId', text: value});
				params.where.push({value: 'entety', text: filter});
			} else if(rootGetters.getRouteName === 'TableWithChart') {
				url = `/mainchartview/assets`;
				params.status = 'DASHBOARD_CHART_REPORT';
				params.chart = chart;
				params.filter = filter;
				params.value = value;
			} else if(rootGetters.getRouteName === 'TableForCalendar') {
				url = `/calendar/assets`;
				params.date = value;
				params.status = filter;
				needExtParams = false;
			}
			if(routerParams.params && needExtParams) {
				params.where = [...params.where, ...routerParams.params];
			}
		}
		try {
			let {http} = await getApi();
			if(progress) dispatch('storeProgress', {text: 'downloading'}, {root: true});
			const response = await http.getData(url, params);
			if(response && response.data && response.data.tabRows) {
				tableViewParams.url = url;
				dispatch('storeTableFinalParams', params)
				dispatch('storeTableRequestParams', tableViewParams)
				commit('setTableRowsCount', response.data.totalRows);
				commit('setTableRows', response.data.tabRows);
				// commit('setNeedToRefreshTable', false);
				return {rows: response.data.tabRows, count: response.data.totalRows}
			}
		} finally {
			if(progress) dispatch('storeProgress', {text: null});
		}
	},
	pushIntoTableRows({commit, getters}, payload) {
		let rows = getters.getTableRows;
		if(payload.index > -1) {
			rows.splice(payload.index, 1, payload.item);
		} else {
			rows.push(payload.item);
			commit('setTableRowsCount', rows.length);
		}
		commit('setTableRows', rows);

	},
	storeFileDialog({commit}, payload) {
		commit('setFileDialog', payload.val)
	},
	refreshTableView({commit}) {
		commit('setTableUpdater')
	}
}

const mutations = {
	setIsParanoid(state, value) {
		state.isParanoid = value;
	},
	setFilter(state, value) {
		state.filter = value;
	},
	setTableRequestParams(state, val) {
		state.requestParams = val
	},
	setTableFinalParams(state, val) {
		state.requestFinalParams = val
	},
	setTableRows(state, val) {
		state.rows = val
	},
	setTableRowsCount(state, val) {
		state.rowsCount = val
	},
	setTableFilterPredicts(state, val) {
		const index = state.filterPredicts.findIndex(one => one.table === val.table && one.route === val.route);
		if(index > -1) {
			state.filterPredicts.splice(index, 1, val)
		} else {
			state.filterPredicts.push(val);
		}
	},
	setFileDialog(state, val) {
		state.fileDialog = val;
	},
	setTableUpdater(state) {
		state.tableUpdater++
	},
	setAssetSearchInputValue(state, val) {
		state.assetSearchInputValue = val
	},
	setAssetSearchInputCheck(state, val) {
		state.assetSearchInputCheck = val
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}
